import React from 'react';
import SelectField from '../../../../../../web-app-components/components/SelectField';
import MenuItem from '@material-ui/core/MenuItem';

const SUITABLE_FOR_OPTIONS = [
  { value: 'solo', label: 'Solo' },
  { value: 'pora', label: 'Pora' },
  { value: 'šeima', label: 'Šeima' },
  { value: 'grupė', label: 'Grupė' },
];

const SuitableForSelectField = (props) => {
  return (
    <SelectField {...props}>
      {SUITABLE_FOR_OPTIONS.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default SuitableForSelectField;
